module.exports = __webpack_public_path__ + "static/media/01_negro.35bb9655.svg";